/**
 * Waits some time.
 *
 * @param milliseconds
 */
export function wait(milliseconds: number): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, milliseconds))
}
